/**
 * "คำแนะนำก่อนใช้บริการ" / "Before you start" block.
 * Data-driven so every page passes its own unique, page-specific advice
 * drawn from that cluster's corpus — never a shared boilerplate list.
 */

export function ServiceAdviceBlock({
  items,
  locale = "th",
  title,
}: {
  items: string[];
  locale?: "th" | "en";
  title?: string;
}) {
  if (!items.length) return null;
  const heading = title ?? (locale === "th" ? "คำแนะนำก่อนเริ่มดำเนินการ" : "Before you start");
  return (
    <section aria-label={heading} className="mt-10 rounded-lg border bg-card p-5">
      <h2 className="mb-3 text-xl font-bold">{heading}</h2>
      <ol className="list-decimal space-y-2 pl-5 text-sm leading-relaxed text-muted-foreground">
        {items.map((t, i) => (
          <li key={i}>{t}</li>
        ))}
      </ol>
    </section>
  );
}